export default class Snippets {
    constructor() {
        const toggles = [...document.querySelectorAll('.extended-toggle')];
        toggles.forEach(toggle => toggle.addEventListener('click', this.toggleExtendedContent.bind(this)));

        const snippets = [...document.querySelectorAll('.snippet')];
        snippets.forEach(snippet => {
            const lastPara = snippet.querySelector('p:last-child');

            if (lastPara) {
                if (lastPara.textContent === '') {
                    lastPara.remove();
                    const h2 = snippet.querySelector('h2');
                    h2.classList.add('mb-0');
                }
            }
        });
    }

    toggleExtendedContent(event) {
        let node = event.target;

        while(!node.classList.contains('snippet')) {
            node = node.parentElement;
        }
    
        node.classList.toggle('show-extended-content');
    }
}